/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import { Button, Divider, Stack, Text } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import useGlobalContext from "../../../hooks/useGlobalContext";
import { useI18n } from "@bookingcom/lingojs-react";
import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { goal, stage, trackWithDefaultStage } from "@flights/et-universal";
import { isOfGoogleFlightsOrigin, isOfMetaOrigin } from "../../../utils/marketing-url-params";
import { preOptedAncillariesURLParams } from "../../../utils/preOptedAncillaries";
import { trackMetaLandingsCustomGoalsV2 } from "../../../utils/experiments/track-meta-landings-v2";
import { UICampaignBadge, UIFetchStatus, UIFlightData } from "@flights/types";
import NotAvailableIllustration from "../../../assets/illustrations/not-available.svg";
import useCreateUrl from "../../../hooks/useCreateUrl";
import { actions as extraProductActions } from "../../../ancillaries/store/extraProducts/actions";
import ErrorAlert from "../ErrorAlert";
import FlightCardPrice from "../FlightCard/components/FlightCardPrice";
import Timeline from "../Timeline";
import { getModalTitle } from "./components/flightDetailsUtils";
import FlightsContentSkeleton from "./components/FlightsContentSkeleton";
import useClientMetrics from "../../../hooks/useClientMetrics";
import { ArrowNavLeftIcon, CloseIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import useStickyFooterSpacerHeight from "../../../hooks/useStickyFooterSpacerHeight";
import useRetryFlightDetailsApi from "../../../hooks/useRetryFlightDetailsApi";
import useGetUrlParams from "../../../hooks/useGetUrlParams";
import useEventTracking from "../../../hooks/useEventTracking";
import Frame from "../Frame";
import { ShareFlight } from "../ShareFlight";
import { CURRENT_ORDER_ID_KEY, PRE_OPTED_ANCILLARIES_QUERY_PARAMS } from "../../../constants";
import styles from "./FlightDetailsInner.module.css";
import flights_mdotvalue_flight_details_back_button from "../../../utils/experiments/mdotvalue/flights_mdotvalue_flight_details_back_button";
import useProfiler from "../../../hooks/useProfiler";
import { FlightCardBadges } from "../FlightCard/components/FlightCardBadges";
import { getCampaignBadgesConfig } from "../../../utils/flightCampaignConfig";
import { FlightCardBadge } from "../FlightCard/components/FlightCardBadge";
import useOfferCartOrderData from "../../../hooks/useOfferCartOrderData";
import { flightsLocalStore, ryanairUtils } from "@flights/web-api-utils-universal";
import { useDispatch, useSelector } from "react-redux";
import { getPreOptedAncillaries } from "../../../ancillaries/store/extraProducts/selectors";
import { getSearchType } from "../../../store/search/selectors";
import { useTrackVICheckedBaggage } from "../../../utils/experiments/funnel/flights_funnel_web_vi_checked_baggage";
import { getSearchCriteria } from "../../../store/searchCriteria/selectors";
import { DSATraceabilityModal } from "./components/DSATraceability";
import FlightDetailsInfoMobile from "./components/FlightDetailsInfo/FlightDetailsInfo.mobile";
import flights_web_meta_to_sr_aa from "../../../utils/experiments/funnel/flights_web_meta_to_sr_aa";
import { clientFetch } from "@flights/client-fetch";
import { WishlistWidgetWrapper } from "../WishlistWidgetWrapper";
import flights_web_condensed_extras_fd_mdot from "../../../utils/experiments/funnel/flights_web_condensed_extras_fd_mdot";
import flights_apex_web_show_included_baggage_asap from "../../../utils/experiments/apex/flights_apex_web_show_included_baggage_asap";
import web_flights_fd_genius_saving_badge from "../../../utils/experiments/genius/web_flights_fd_genius_saving_badge";
import { SurveyTrackerLoader } from "../../remote/SurveyTrackerFlightsUniversal";
import flights_split_bounds_us, {
  useSplitBoundsCondition
} from "../../../utils/experiments/funnel/flights_split_bounds_us";
import flights_web_fd_baggage_transparency from "../../../utils/experiments/funnel/flights_web_fd_baggage_transparency";
import flights_apex_web_ryanair_ancillaries_price_label from "../../../utils/experiments/apex/flights_apex_web_ryanair_ancillaries_price_label";
import { trackMetaCustomGoal, trackMetaExperimentStage } from "../../../utils/meta-et-tracking";
import { flightsSessionStore } from "@flights/web-api-utils-universal";

const FLIGHT_DETAILS_STICKY_FOOTER_SPACER_ID = "flight-details-sticky-footer-spacer";

type Props = {
  // In Meta flow `flight` prop might be a response of `/flightFromOfferRelatedFlights`,
  // its response `token` different from the one in request and unusable for checkout.
  // `flightToken` prop is guaranteed to be the full flight details token and must be used for checkout.
  flightToken: string;
  flight?: UIFlightData;

  fetchStatus: UIFetchStatus;
  onClose: VoidFunction;
  onErrorClose: VoidFunction;
  hideFooter?: boolean;
  closeAriaLabel?: string;
  hasPrefetchedBrandedFareOffers?: boolean;
  alternativeFaresFlow?: boolean;
};

const FlightDetailsInner: FC<Props> = ({
  flight,
  flightToken,
  fetchStatus,
  onClose,
  onErrorClose,
  hideFooter,
  closeAriaLabel,
  hasPrefetchedBrandedFareOffers,
  alternativeFaresFlow
}) => {
  const history = useHistory();
  const i18n = useI18n();
  const { createUrl } = useCreateUrl();
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const { trackClientMetric } = useClientMetrics();
  const { getUrlParam } = useGetUrlParams();
  const { requestId } = useGlobalContext();
  const { isRetryableFlightDetails } = useRetryFlightDetailsApi();
  const trackV2 = useEventTracking("flight_details", requestId);
  const { isLoggedIn, isMeta, isDirect, isSolo } = useProfiler();
  const offerCartOrderData = useOfferCartOrderData();
  const preOptedAncillaries = useSelector(getPreOptedAncillaries);
  const searchType = useSelector(getSearchType);

  const XM_SURVEY_EXP = "m_xm_flights_details";
  useEffect(() => {
    stage(XM_SURVEY_EXP, 1);
    if (isLoggedIn()) {
      stage(XM_SURVEY_EXP, 2);
    } else {
      stage(XM_SURVEY_EXP, 3);
    }
    if (isDirect()) {
      stage(XM_SURVEY_EXP, 4);
    } else if (isMeta()) {
      stage(XM_SURVEY_EXP, 5);
    }
  }, [XM_SURVEY_EXP, isLoggedIn, isDirect, isMeta]);

  useEffect(() => {
    const { parentOfferToken } = offerCartOrderData.get(flightToken);
    offerCartOrderData.set(flightToken, { offer: flightToken, parentOfferToken: parentOfferToken || flightToken });
  }, [flightToken, offerCartOrderData]);

  useEffect(() => {
    if (fetchStatus == "success") {
      // if all segment include three types of baggages
      /* start - flights_web_condensed_extras_fd_mdot */
      flights_web_condensed_extras_fd_mdot.stages.fetchedFD();
      /* end - flights_web_condensed_extras_fd_mdot */
    }
  }, [
    fetchStatus,
    flight?.includedProducts?.areAllSegmentsIdentical,
    flight?.includedProducts?.segments,
    flight?.segments
  ]);

  useEffect(() => {
    if (isLoggedIn() && flight) {
      web_flights_fd_genius_saving_badge.stages.land_on_fd();
    }
  }, [flight, isLoggedIn, isSolo]);

  const onFlightSelect = () => {
    if (flight) {
      flights_mdotvalue_flight_details_back_button.goals.onNextStep();
      flights_mdotvalue_flight_details_back_button.goals.onFlightExit();

      const orderId = flightsLocalStore.get(CURRENT_ORDER_ID_KEY);

      if (alternativeFaresFlow) {
        void clientFetch("/api/order/track-alternative-fares-event", {
          method: "POST",
          body: JSON.stringify({
            eventType: "ALTERNATIVE_FARE_SELECTED",
            orderId,
            selectedOffer: flight
          }),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json"
          }
        });
      }

      trackMetaLandingsCustomGoalsV2(3, "mdot"); // track custom goal 3: users progressing beyond FD for meta

      /* start - flights_apex_web_show_included_baggage_asap */
      const isMeta = isOfMetaOrigin();
      const baggageIncluded = Boolean(flight.includedProducts?.segments.some((segment) => segment.length > 0));
      if (baggageIncluded && !isMeta && fetchStatus === "loading") {
        flights_apex_web_show_included_baggage_asap.stages.extras_not_loaded_clicked_next();
      }
      /* end - flights_apex_web_show_included_baggage_asap */

      const landingOfferKey = flightsSessionStore.get("landingOfferKey");

      trackMetaCustomGoal("flights_web_cat_pinning_meta_offer_on_sr_mdot", 1);
      if (flightToken === landingOfferKey) {
        trackMetaCustomGoal("flights_web_cat_pinning_meta_offer_on_sr_mdot", 2);
      }

      if (fetchStatus !== "success") {
        trackClientMetric("flight_details_quick_checkout_start");
      }

      trackV2("select_flight_details_next");
      goal("flights_flight_details_action_click");
      goToCheckout(flightToken);
    }
  };

  //Use this in case flexible Ticket is already selected from meta on flight details. So next screen would be checkout pax.
  const goToCheckout = useCallback(
    (flightToken: string) => {
      let preOpted = preOptedAncillaries;

      if (getUrlParam(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.flexibleTicket)) {
        preOpted = { ...preOpted, flexibleTicket: true };
      }

      const urlParams = preOptedAncillariesURLParams(preOpted);

      const baseOfferToken = getUrlParam("baseOfferToken");
      if (baseOfferToken) urlParams.set("baseOfferToken", baseOfferToken);

      if (hasPrefetchedBrandedFareOffers) {
        urlParams.set("hasPrefetchedBrandedFareOffers", "true");
      }

      /** start - flights_ace_web_prevent_double_cart_creation_for_bf **/
      urlParams.set("bfPageLoadTimeStart", performance.now().toString());
      /** end - flights_ace_web_prevent_double_cart_creation_for_bf **/

      const url = createUrl(`/checkout/start/${flightToken}?${urlParams}`);

      history.push(url);
    },
    [preOptedAncillaries, history, createUrl, getUrlParam, hasPrefetchedBrandedFareOffers]
  );

  useEffect(() => {
    if (fetchStatus === "failed") {
      trackV2("show_error_page");
    }
  }, [fetchStatus, flight, isRetryableFlightDetails, trackV2]);

  const trackMetaTraffic = flights_web_meta_to_sr_aa.useTrackStages();

  const isError = fetchStatus === "failed" && !(flight && isRetryableFlightDetails());

  useTrackVICheckedBaggage();

  if (isError) {
    goal("flights_flight_details_loading_error");

    return (
      <ErrorAlert
        illustration={<NotAvailableIllustration />}
        title={i18n.trans(t("flights_error_unavailable"))}
        body={i18n.trans(t("flights_error_unavailable_body"))}
        buttonLabel={i18n.trans(t("flights_search_action"))}
        onClick={onErrorClose}
      />
    );
  }

  const modalTitle = getModalTitle(i18n, flight?.segments, searchType, true);

  const trackAndClose = () => {
    trackV2("click_back_button");
    flights_mdotvalue_flight_details_back_button.goals.onBackToSr();
    flights_mdotvalue_flight_details_back_button.goals.onBackToSrClick();
    flights_mdotvalue_flight_details_back_button.goals.onFlightExit();
    flights_web_fd_baggage_transparency.goals.close_fd();
    trackMetaTraffic();
    trackMetaExperimentStage("flights_web_cat_pinning_meta_offer_on_sr_mdot", 1);
    if (!!trackWithDefaultStage("flights_merch_toolkit_offer_pinning_v2", 1)) {
      trackMetaExperimentStage("flights_web_cat_pinning_meta_offer_on_sr_mdot", 2);
    }
    onClose();
  };

  const shouldShowWishlistWidget = isLoggedIn();

  const campaignBadges: UICampaignBadge[] =
    fetchStatus === "success" ? flight?.campaignDisplay?.badges?.filter((badge) => badge.style !== "VIVID") ?? [] : [];

  if (flight && ryanairUtils.isRyanairFlightOffer(flight)) {
    flights_apex_web_ryanair_ancillaries_price_label.stages.fd();
    flights_apex_web_ryanair_ancillaries_price_label.stages.fd_mdot();
  }

  return (
    <Frame pt={2} pb={4} pl={4} pr={4}>
      <FlightDetailsInnerHeader title={modalTitle} onCloseClick={trackAndClose} closeAriaLabel={closeAriaLabel} />
      <>
        {flight ? (
          <div>
            <Stack direction="row" alignItems="center" mixin={{ paddingBlockEnd: 4 }}>
              {campaignBadges.length > 0 && <FlightDetailsCampaignBadgeSection campaignBadges={campaignBadges} />}
              {shouldShowWishlistWidget && flight.offerKeyToHighlight && (
                <div className={campaignBadges.length === 0 ? styles.withMargin : undefined}>
                  <WishlistWidgetWrapper flight={flight} />
                </div>
              )}
              <Frame>
                <ShareFlight flight={flight} />
              </Frame>
            </Stack>

            <Timeline segments={flight.segments} />

            <Stack gap={4} mixin={{ paddingBlockEnd: 4 }}>
              <Divider />
              <FlightDetailsInfoMobile flight={flight} fetchStatus={fetchStatus} />
            </Stack>

            <SurveyTrackerLoader />

            <DSATraceabilityModal flight={flight} />
          </div>
        ) : (
          <FlightsContentSkeleton />
        )}
        {!hideFooter && (
          <>
            <div id={FLIGHT_DETAILS_STICKY_FOOTER_SPACER_ID} />
            <Footer flight={flight} onButtonClick={onFlightSelect} fetchStatus={fetchStatus} />
          </>
        )}
      </>
    </Frame>
  );
};

const FlightDetailsInnerHeader: FC<{
  onCloseClick?: () => void;
  title: string;
  closeAriaLabel?: string;
}> = ({ onCloseClick, title, closeAriaLabel }) => {
  const i18n = useI18n();
  const [isFocusedOnClose, setIsFocusedOnClose] = useState(false);
  const closeBtnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (isFocusedOnClose) return;
    if (!closeBtnRef?.current) return;
    closeBtnRef.current.focus();
    setIsFocusedOnClose(true);
  }, [isFocusedOnClose, closeBtnRef]);

  // START - flights_mdotvalue_flight_details_back_button
  const isExpWithBackButtonEligible = flights_mdotvalue_flight_details_back_button.useUserEligibility();
  const isExpWithBackButtonVariant = flights_mdotvalue_flight_details_back_button.trackWithDefaultStage() > 0;
  const trackBackButtonExpStages = flights_mdotvalue_flight_details_back_button.useTrackStages();
  if (isExpWithBackButtonEligible) {
    trackBackButtonExpStages();
  }
  const alignItems = isExpWithBackButtonEligible && isExpWithBackButtonVariant ? "center" : undefined;
  // END - flights_mdotvalue_flight_details_back_button

  return (
    <div className={styles.header}>
      <Stack gap={0} direction="row" alignItems={alignItems}>
        {isExpWithBackButtonEligible && isExpWithBackButtonVariant && (
          <Button
            size="large"
            variant="tertiary-neutral"
            className={styles.headerBackButton}
            ref={closeBtnRef}
            attributes={{
              "aria-label": closeAriaLabel || i18n.trans(t("flights_action_close"))
            }}
            icon={<ArrowNavLeftIcon />}
            onClick={() => {
              onCloseClick?.();
            }}
          ></Button>
        )}

        <Text variant="headline_2" tagName="h1" className={styles.headerCrossText}>
          {title}
        </Text>

        {!(isExpWithBackButtonEligible && isExpWithBackButtonVariant) && (
          <Button
            size="large"
            variant="tertiary-neutral"
            ref={closeBtnRef}
            attributes={{
              "aria-label": closeAriaLabel || i18n.trans(t("flights_action_close"))
            }}
            icon={<CloseIcon />}
            onClick={() => {
              onCloseClick?.();
            }}
          ></Button>
        )}
      </Stack>
    </div>
  );
};

const Footer: FC<{
  flight?: UIFlightData;
  onButtonClick: () => void;
  /* start - flights_split_bounds_us */
  fetchStatus: UIFetchStatus;
  /* end - flights_split_bounds_us */
}> = ({ flight, onButtonClick, fetchStatus }) => {
  const i18n = useI18n();
  const [breakdownOpen, setBreakdownOpen] = useState(false);
  const footerContainerRef = useRef<HTMLDivElement>(null);
  useStickyFooterSpacerHeight(footerContainerRef, FLIGHT_DETAILS_STICKY_FOOTER_SPACER_ID);
  const { getUrlParam } = useGetUrlParams();
  const { features } = useGlobalContext();
  const enableGfsPosMismatch = features["FLIGHTS_META_ENABLE_GFS_FOR_POS_MISMATCH"] && isOfGoogleFlightsOrigin();
  const isFlexTicket = !!getUrlParam(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.flexibleTicket);
  const dispatch = useDispatch();
  const { children } = useSelector(getSearchCriteria);
  const { isSplitBounds } = useSplitBoundsCondition();

  const handleBreakdownOpen = React.useCallback<(status: boolean) => void>((status) => {
    setBreakdownOpen(status);
  }, []);

  useEffect(() => {
    if (isFlexTicket) {
      dispatch(extraProductActions.addPreOptInProduct("flexibleTicket", true));
      return;
    }

    dispatch(extraProductActions.removePreOptInProduct("flexibleTicket"));
  }, [dispatch, isFlexTicket]);

  useEffect(() => {
    fetchStatus === "success" && flights_split_bounds_us.goals.fd_fully_loaded();
  }, [fetchStatus]);

  return (
    <Frame direction="row" alignItems="center" className={styles.footer}>
      <div ref={footerContainerRef} className={styles.footerContainer}>
        <div className={styles.priceWrapper}>
          {!!flight && (
            <FlightCardPrice
              flight={flight}
              alignment="start"
              totalPriceLabel={i18n.trans(t("flights_fd_price_multi"))}
              breakdownOpen={breakdownOpen}
              setBreakdownOpen={handleBreakdownOpen}
              showTotalPriceIncludingAncillaries={true}
              showAvailableSeats={true}
              showPricePerPerson={false}
              isFlexTicket={!!getUrlParam(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.flexibleTicket)}
              popoverCloseAriaLabel={i18n.trans(t("flights_a11y_price_breakdown_close_fd"))}
              showPricePerTraveller={children.length > 0}
              totalPriceTagName="h2"
            />
          )}
        </div>
        <div data-testid="flight_details_inner_modal_select_button">
          <Button
            text={i18n.trans(t("flights_details_select_button"))}
            size="large"
            onClick={onButtonClick}
            className={styles.footerButton}
            loading={!flight || (!enableGfsPosMismatch && flight.posMismatch?.isPOSMismatch)}
            loadingAriaLabel={isSplitBounds ? i18n.trans(t("a11y_flights_fd_cta_spinner_loading")) : ""}
          />
        </div>
      </div>
    </Frame>
  );
};

export const FlightDetailsCampaignBadgeSection = ({ campaignBadges }: { campaignBadges?: UICampaignBadge[] }) => {
  const badges = getCampaignBadgesConfig(campaignBadges);

  return badges.length > 0 ? (
    <FlightCardBadges>
      {badges.map((badge, idx) => (
        <FlightCardBadge key={`keyCampaignBadge-${idx}`} alternative={false} isInteractive={false} {...badge} />
      ))}
    </FlightCardBadges>
  ) : null;
};

export default FlightDetailsInner;
